import { render } from "./Home.vue?vue&type=template&id=c5896470&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "@/assets/style.css?vue&type=style&index=0&lang=css"
import "./Home.vue?vue&type=style&index=1&id=c5896470&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c5896470"]])

export default __exports__